import { useState, useEffect, useMemo } from 'react';

const GRID = { xs: 0, sm: 576, md: 768, lg: 992, xl: 1200, xxl: 1540 };

/** md 以下含手机横屏（宽≥768 但高度不足） */
function downMd(width, height) {
	return width < GRID.md || (height < GRID.sm && width < GRID.lg);
}

export const useBreakpoints = () => {
	const [width, setWidth] = useState(window.innerWidth);
	const [height, setHeight] = useState(window.innerHeight);

	useEffect(() => {
		const update = () => {
			setWidth(window.innerWidth);
			setHeight(window.innerHeight);
		};
		window.addEventListener('resize', update);
		return () => window.removeEventListener('resize', update);
	}, []);

	const breakpoints = useMemo(
		() => ({
			down: (bp) => (bp === 'md' ? downMd(width, height) : width < GRID[bp]),
		}),
		[width, height],
	);

	return { breakpoints, width, height };
};
